import { HeaderColumns } from './header'
import { Footer } from './footer'
import { Body } from './body'

export const Table = {
  HeaderColumns,
  Body,
  Footer
}
